import { AppListPage } from '@/features/access/pages/app/AppListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/app/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_app.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: AppListPage,
})
